import { render } from "./HeroMain.vue?vue&type=template&id=74d91c1c&scoped=true"
const script = {}

import "./HeroMain.vue?vue&type=style&index=0&id=74d91c1c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d91c1c"]])

export default __exports__